import { mapState } from "vuex";
import { PLAN_NO } from "@/contants/plan";

export default {
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    isLimitStartCampaign () {
      switch (this.item.page_type) {
        case 'template-product':
          return (
            this.shopInfo.plan === PLAN_NO.BUILD
            && this.shopInfo.publishedProductPagesCount >= this.shopInfo.planLimitation[PLAN_NO.BUILD].pagePublish.nbOfPublishedProductPage
            && !this.item.main_page_is_published
          )
        case 'template-article':
          return (
            this.shopInfo.plan === PLAN_NO.BUILD
            && this.shopInfo.publishedArticlePagesCount >= this.shopInfo.planLimitation[PLAN_NO.BUILD].pagePublish.nbOfPublishedArticlePage
            && !this.item.main_page_is_published
          )
        default:
          return false;
      }
    }
  }
}
